/* Native tag and pagination links still work without JavaScript. */
(() => {
  const managed=new Map();
  function journal(root) {
    const results=root.querySelector('[data-journal-results]');
    const select=root.querySelector('[data-journal-select]');
    const announcement=root.querySelector('[data-journal-announcement]');
    const filters=[...root.querySelectorAll('[data-journal-filter]')];
    const basePath=new URL(filters[0].href).pathname;
    let controller=null, version=0;
    root.classList.add('lb-journal-enhanced');
    root.querySelector('.lb-journal-select').hidden=false;
    const sync=path=>{
      filters.forEach(link=>{
        if(new URL(link.href).pathname===path)link.setAttribute('aria-current','page');
        else link.removeAttribute('aria-current');
      });
      const option=[...select.options].find(option=>new URL(option.value,location.origin).pathname===path);
      if(option)select.value=option.value;
    };
    const resultsTop=()=>{
      const header=document.querySelector('.lb-header');
      const banner=document.querySelector('.lb-announcement');
      return Math.max(0,scrollY+results.getBoundingClientRect().top-(header?.offsetHeight||0)-(banner?.offsetHeight||0)-24);
    };
    const navigate=async(url,{pagination=false,restoreY=null,historyEntry=true}={})=>{
      controller?.abort();controller=new AbortController();const request=++version;
      results.style.minHeight=results.getBoundingClientRect().height+'px';
      results.setAttribute('aria-busy','true');
      announcement.textContent='Loading stories…';
      try{
        const response=await fetch(url,{signal:controller.signal,headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error('Stories could not be loaded');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const next=doc.querySelector('[data-journal-results]');
        if(!next)throw new Error('The Journal is unavailable');
        if(request!==version)return;
        if(historyEntry){
          history.replaceState({...history.state,lbJournalY:scrollY},'',location.href);
          history.pushState({lbJournalY:pagination?resultsTop():scrollY},'',url);
        }
        results.dispatchEvent(new CustomEvent('littlebird:content:unload',{bubbles:true}));
        results.replaceChildren(...next.childNodes);
        results.style.minHeight='';
        results.setAttribute('aria-busy','false');
        sync(new URL(url,location.href).pathname);
        document.title=doc.title;
        results.dispatchEvent(new CustomEvent('littlebird:content:load',{bubbles:true}));
        const count=results.querySelector('[data-journal-count]').textContent.trim();
        const page=results.querySelector('.lb-pagination-status')?.textContent.trim();
        announcement.textContent=[count,page].filter(Boolean).join('. ');
        if(restoreY!==null)window.scrollTo({top:restoreY,behavior:'instant'});
        else if(pagination){
          window.scrollTo({top:resultsTop(),behavior:'instant'});
          const heading=results.querySelector('h2');
          if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}
        }
      }catch(error){
        if(error.name!=='AbortError' && request===version)location.assign(url);
      }finally{
        if(request===version){results.style.minHeight='';results.setAttribute('aria-busy','false');}
      }
    };
    const click=event=>{
      const link=event.target.closest('[data-journal-filter],.lb-journal-pagination a');
      if(!link || !root.contains(link) || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
      event.preventDefault();
      if(link.href===location.href && !controller?.signal.aborted && results.getAttribute('aria-busy')!=='true')return;
      navigate(link.href,{pagination:!!link.closest('.lb-journal-pagination')});
    };
    const change=()=>navigate(new URL(select.value,location.origin).href);
    const pop=event=>{
      if(location.pathname===basePath||location.pathname.startsWith(basePath+'/tagged/'))navigate(location.href,{historyEntry:false,restoreY:event.state?.lbJournalY??0});
    };
    root.addEventListener('click',click);select.addEventListener('change',change);window.addEventListener('popstate',pop);
    return ()=>{controller?.abort();root.removeEventListener('click',click);select.removeEventListener('change',change);window.removeEventListener('popstate',pop);};
  }
  const init=root=>root.querySelectorAll('[data-journal]').forEach(element=>{if(!managed.has(element))managed.set(element,journal(element));});
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>managed.forEach((cleanup,element)=>{if(event.target.contains(element)){cleanup();managed.delete(element);}}));
})();
